var mensPants = {
  category: "Men's",
  product: "Pants + Shorts",
  sections: [{
      section: {
        title: "Find Your Bluffworks Waist Size",
        type: "table",
        header: [   
          "Pant Waist",
          "",
          "Your Waist",
          "Your Hips",
          "Your Thigh",
        ],
        rows: [
          ["29", "", "31",  "36",  "20.5 - 21"],
          ["30", "", '32',  "37",  "21 - 21.5"],
          ["31", "", '33',  "38",  "22 - 22.5"],
          ["32", "", '34',  "39",  "22.5 - 23"],
          ["33", "", '35',  "40",  "23.5 - 24"],
          ["34", "", '36',  "41",  "24 - 24.5"],
          ["35", "", '37',  "42",  "25 - 25.5"],
          ["36", "", '38',  "43",  "25.5 - 26"],
          ["38", "", '40',  "45",  "27.5 - 28"],
          ["40", "", '42',  "47",  "29 - 29.5"]
        ]
      }
    },
             {
      section: {
        title: "Find Your Bluffworks Size (S/M/L/XL)",
        type: "table",
        header: [
          "Size",
          "Your Waist",
          "Your Hips",
          "Your Thigh",
        ],
        rows: [
          ["S",  "31",  "36",  "20.5 - 21"],
          ["S",  '32',  "37",  "21 - 21.5"],
          ["S",  '33',  "38",  "22 - 22.5"],
          ["M",  '34',  "39",  "22.5 - 23"],
          ["M",  '35',  "40",  "23.5 - 24"],
          ["M",  '36',  "41",  "24 - 24.5"],
          ["L",  '37',  "42",  "25 - 25.5"],
          ["L",  '38',  "43",  "25.5 - 26"],
          ["XL", '40',  "45",  "27.5 - 28"],
          ["XL", '42',  "47",  "29 - 29.5"]
        ]
      }
    },
    {
      section: {
        title: "Fit Guidance",
        type: "twoCol",
        columns: [
          [{
            img: "https://cdn.shopify.com/s/files/1/0167/5514/files/Men_s_Pants_-_Regular_1d6717c3-b011-4367-a692-00f4622ebb72.png?16985",
            title: "Regular:",
            body: "Ease throughout the hips and thigh. Sits just below the natural waist with a straight leg."
          }],
          [{
            img: "https://cdn.shopify.com/s/files/1/0167/5514/files/Men_s_Pants_-_Tailored2.png?v=1698094061",
            title: "Tailored:",
            body: "Similar ease throughout the hips and thigh as our Regular Fit. Sits just below the natural waist and has a straight leg with slight tapering below the knee."
          }],
          [{
            img: "https://cdn.shopify.com/s/files/1/0167/5514/files/Men_s_Pants_-_Slim2.png?v=1698094061",
            title: "Slim:",
            body: "Our most fitted pant through the hips, thigh, and leg. Sits at the hip with a slightly shorter rise and has a narrow, tapered leg throughout."
          }]
        ]
      }
    },
    {
      section: {
        title: 'How to Measure',
        type: "singleCol",
        columns: [
          [{
            img: "https://cdn.shopify.com/s/files/1/0167/5514/files/Mens_-_How_To_Measure.png?14026"
          }],
          [{
            title: "Neck: ",
            body: "Wrap the measuring tape loosely around the base of your neck, keeping one finger between your neck and the tape."
          }],
          [{
            title: "Arm (Spine to Wrist): ",
            body: "The arm measurement used for sleeve length is measured from the center back of the neck to wrist. Hold your arm out to the side with your elbow slightly bent, and measure from the back center of your neck (your spine) down the outside of your arm to your wrist bone."
          }],
          [{
            title: "Chest: ",
            body: "Wrap the measuring tape around the circumference of your chest at the widest point, approximately 1\"/2.5 cm below your armpit. Inhale, exhale, and then place a finger behind the tape. Keep the tape level and snug, but not too tight."
          }],
          [{
            title: "Natural Waist: ",
            body: "Bend to the side to find the natural crease of your waist. Wrap the measuring tape at this point, keeping the tape slightly loose."
          }],
          [{
            title: "Waist: ",
            body: "Wrap the measuring tape around your waistline (where you want your pants to sit), keeping the tape slightly loose. Bluffworks pants are offered in 1\"/2.5 cm increments, so we suggest sizing up if you're between sizes."
          }],
          [{
            title: "Hips: ",
            body: "Keep feet together, and wrap the measuring tape around the fullest part of your seat (approximately 8\"/20.3 cm below your natural waist), keeping the tape slightly loose."
          }],
          [{
            title: "Thigh: ",
            body: "Wrap the measuring tape around the fullest part of the thigh (approximately 1\"/2.5 cm below the crotch), keeping the tape slightly loose."
          }]
        ]
      }
    }
  ]
};